import { makeSubmitEditableTableChanges } from "api/makeApiRequestType/makeSubmitEditableTableChanges";
import { OutputRow as AvailabilityData } from "api/getAvailability";

export const saveMentorAvailabilityPeriods = makeSubmitEditableTableChanges<
	AvailabilityData
>("mentorAvailabilityPeriods");
